import { ReactNode } from 'react';
import { Header } from '@amzn/awsui-components-core';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import baseStyles from './ActionPanel.module.scss';

interface ActionPanelBaseProps {
  readonly title: string;
  readonly children: ReactNode;
}

/**
 * Shared panel chrome: white full-height container with a header (title + close button).
 * Individual panel variants wrap their content in this.
 */
export default function ActionPanelBase({ title, children }: ActionPanelBaseProps) {
  return (
    <div className={baseStyles.panel}>
      <div className={baseStyles.headerWithDivider}>
        <Header variant="h2">{title}</Header>
      </div>
      <SimpleBar className={baseStyles.content}>
        <div className={baseStyles.contentInner}>{children}</div>
      </SimpleBar>
    </div>
  );
}
